<template>
	<view class="address">
		<view class="address_list">
			<view class="address_list_item">
				<view class="label">收货人</view>
				<input type="text" placeholder="名字" placeholder-style="color: #999999; font-size: 28rpx; font-weight: 400;" />
			</view>
			<view class="address_list_item">
				<view class="label">手机号码</view>
				<input type="text" placeholder="手机号" placeholder-style="color: #999999; font-size: 28rpx; font-weight: 400;" />
			</view>
			<view class="address_list_item" @click="openArea">
				<view class="label">所在地区</view>
				<view class="box">省、市、区</view>
			</view>
			<view class="address_list_item">
				<view class="label">详细地址</view>
				<textarea placeholder="小区楼栋" placeholder-style="color: #999999; font-size: 28rpx; font-weight: 400;"></textarea>
			</view>
			<view class="address_list_item center">
				<view class="label">设为默认收货地址</view>
				<switch checked color="#D20A0A" style="transform:scale(0.8)" />
			</view>
		</view>
		<view class="address_submit">
			<view class="address_submit_btn">保存</view>
			<view class="address_submit_dele">删除</view>
		</view>
		<!-- 省市区 -->
		<uni-popup ref="area" background-color="#fff">
			<view class="date">
				<view class="title">
					<text>请选择所在地区</text>
					<view class="title_icon" @click="closeArea">
						<uni-icons color="#CCCCCB" type="closeempty" size="20"></uni-icons>
					</view>
				</view>
				<view class="content">
					<picker-view
						:indicator-style="indicatorStyle"
						:value="date"
						:immediate-change="true"
						@change="bindChangeDate"
						class="picker-view">
						<picker-view-column>
							<view class="item" v-for="(item,index) in economize" :key="index">{{item.name}}</view>
						</picker-view-column>
						<picker-view-column>
							<view class="item" v-for="(item,index) in market" :key="index">{{item.name}}</view>
						</picker-view-column>
						<picker-view-column>
							<view class="item" v-for="(item,index) in area" :key="index">{{item.name}}</view>
						</picker-view-column>
					</picker-view>
				</view>
				<view class="submit" @click="updateSex">确定</view>
			</view>
		</uni-popup>
	</view>
</template>

<script>
	import {city} from '@/common/city.js'
	export default {
		data() {
			return {
				indicatorStyle: 'height: 40px;',
				date: [1,1,1],
				economize: [],
				market: [],
				area: []
			}
		},
		onLoad() {
			city.forEach((item, index) => {
				if (index === 0) {
					this.market = item.cityList
					item.cityList.forEach((child, i) => {
						if (i === 0) {
							this.area = child.areaList
						}
					})
				}
				this.economize.push(item)
			})
		},
		methods: {
			bindChangeDate(e) {
				this.market = city[e.detail.value[0]].cityList
				this.area = city[e.detail.value[0]].cityList[e.detail.value[1]].areaList
			},
			updateSex() {
				
			},
			closeArea() {
				this.$refs.area.close()
			},
			openArea() {
				this.$refs.area.open('bottom')
			}
		}
	}
</script>

<style>
	.uni-popup__wrapper {
		border-radius: 32rpx !important;
	}
</style>

<style lang="scss" scoped>
	.address {
		width: 100%;
		.address_list {
			padding: 36rpx 32rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			.center {
				display: flex !important;
				align-items: center !important;
			}
			.address_list_item {
				display: flex;
				align-items: center;
				margin-bottom: 36rpx;
				&:last-child {
					margin-bottom: 0 !important;
				}
				.label {
					flex: 1;
					text-align: left;
					font-size: 32rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #333333;
				}
				.active {
					font-size: 28rpx !important;
					font-weight: 400 !important;
					color: #333333 !important;
				}
				.box {
					width: 530rpx;
					height: 92rpx;
					line-height: 92rpx;
					font-size: 28rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #999999;
					border-radius: 16rpx;
					background: #F5F5F5;
					padding: 0 28rpx;
					box-sizing: border-box;
				}
				input {
					width: 530rpx;
					height: 92rpx;
					font-size: 28rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #333333;
					border-radius: 16rpx;
					background: #F5F5F5;
					padding: 0 28rpx;
					box-sizing: border-box;
				}
				textarea {
					width: 530rpx;
					height: 140rpx;
					background: #F5F5F5;
					padding: 32rpx 28rpx;
					box-sizing: border-box;
					border-radius: 16rpx;
					font-size: 28rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #333333;
				}
			}
		}
		.address_submit {
			margin-top: 40rpx;
			padding: 0 56rpx;
			box-sizing: border-box;
			.address_submit_btn {
				width: 100%;
				height: 72rpx;
				line-height: 72rpx;
				text-align: center;
				background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
				border-radius: 36rpx;
				font-size: 32rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
			}
			.address_submit_dele {
				width: 100%;
				height: 72rpx;
				line-height: 72rpx;
				text-align: center;
				border-radius: 56rpx;
				border: 2rpx solid #D20A0A;
				font-size: 32rpx;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #D20A0A;
				margin-top: 30rpx;
			}
		}
		.date {
			padding: 44rpx 32rpx;
			background-color: #FFFFFF;
			box-sizing: border-box;
			.title {
				width: 100%;
				text-align: center;
				position: relative;
				text {
					font-size: 32rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #333333;
				}
				.title_icon {
					position: absolute;
					right: 0;
					top: 0;
				}
			}
			.content {
				width: 100%;
				margin-top: 80rpx;
				.picker-view {
					width: 100%;
					height: 400rpx;
					.item {
						height: 40px;
						line-height: 40px;
						text-align: center;
					}
				}
			}
			.submit {
				width: 100%;
				height: 72rpx;
				line-height: 72rpx;
				text-align: center;
				background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
				border-radius: 36rpx;
				font-size: 32rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
				margin-top: 50rpx;
			}
		}
	}
</style>